var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 11",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.28.361a1.163 1.163 0 01-.04 1.643l-8.137 7.752a1.163 1.163 0 01-1.604 0L.36 2.006A1.163 1.163 0 111.964.321l7.338 6.99L16.638.32A1.163 1.163 0 0118.28.36z",
    fill: "#333230"
  })));
}
export default SvgPldChevronDown;